
import React, { PureComponent } from 'react'
import { Modal, Col, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputSelect from '../../../commons/form/InputSelect'
import InputNumber from '../../../commons/form/InputNumber'
import { handleKeyDown } from '../../../../util/utils'
class ProcessingAgencyIntegrationRegistrationTypesMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = {}
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      this.props.initialize(this.props.processingAgencyRegistrationType)
    }
  }

  submitProcessingAgencyRegistrationType (values) {
    const processingAgencyRegistrationType = {
      ProcessingAgencyRegistrationTypeId: this.props.processingAgencyRegistrationType?.processingAgencyRegistrationTypeId,
      ProcessingAgencyId: this.props.agency.processingAgencyId,
      DossierOperationTypeId: values.dossierOperationTypeId,
      RegistrationTypeId: values.registrationTypeId
    }

    this.props.actions.submitProcessingAgencyRegistrationTypes(this.props.agency.processingAgencyId, processingAgencyRegistrationType)
  }

  render () {
    const {
      t, handleSubmit,
      showModal
    } = this.props
    const tKey = 'MASTERS.PROCESSING_AGENCY_MASTERS.REGISTRATION_TYPES.'
    return (
      <Modal id="processingAgencyIntegrationRegistrationTypesMasterModal" className="_nf" show={showModal} onHide={() => this.props.actions.showProcessingAgencyRegistrationTypesModal(null, false)} backdrop={'static'}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitProcessingAgencyRegistrationType.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={() => this.props.actions.showProcessingAgencyRegistrationTypesModal(null, false)}>
            <Modal.Title>{t(`${tKey}REGISTRATION_TYPES`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="dossierOperationTypeId"
                controlLabel={t(`${tKey}OPERATION_TYPE`)}
                placeholder={t(`${tKey}OPERATION_TYPE`)}
                options={this.props.combos.operationTypeAllCombo}
                valueKey="id"
                labelKey="value"
              />
              <Field
                component={InputNumber}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="registrationTypeId"
                controlLabel={t(`${tKey}REGISTRATION_TYPE`)}
                placeholder={t(`${tKey}REGISTRATION_TYPE`)}
                required={[true]}
                maxLength={50}
                colSm={0}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R">
              <Button
                id="role-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}MODAL.SUBMIT_BUTTON`)}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'editProcessingAgencyRegistrationTypeModal',
  validate: (values, props) => {
    let error = {}
    const tKey = 'MASTERS.PROCESSING_AGENCY_MASTERS.DOC_TYPE_USES.VALIDATION.'
    if (!values.dossierOperationTypeId) {
      error.dossierOperationTypeId = props.t(`${tKey}VALUE_REQUIRED`)
    }
    if (!values.registrationTypeId) {
      error.registrationTypeId = props.t(`${tKey}VALUE_REQUIRED`)
    }

    return Object.keys(error).length > 0 ? error : {}
  }
})(ProcessingAgencyIntegrationRegistrationTypesMasterModal)
